import style from './../../adminSect.module.scss';

const NewPharmacyFields = () => {
  const { inputPadding } = style;


  const fields = [
    {
      item: {
        label: 'Número de cuenta',
        name: 'accountNumber',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese su número de cuenta',
          },
        ],
      },
      input: {
        className: inputPadding,
        style: {marginBottom: '1rem'},
        type: 'number'
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: '¿Que tipo de cuenta es?',
        name: 'role',
        rules: [
          {
            required: true,
            message: 'Por favor elegir un tipo de cuenta'
          }
        ]
      },
      radio: [
        {
          value: 'admin',
          label: 'Admin'
        },
        {
          value: 'pharmacy',
          label: 'Farmacia'
        },
        {
          value: 'supplier',
          label: 'Proveedor'
        }
      ],
      inputTag: 'radio'
    },
    {
      item: {
        label: 'Nombre de la farmácia',
        name: 'name',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el nombre de la farmácia',
          },
        ],
      },
      input: {
        className: inputPadding
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Nombre del dueño',
        name: 'owner',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese nombre del dueño de la farmácia',
          },
        ],
      },
      input: {
        className: inputPadding
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Número de teléfono',
        name: 'cellPhone',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese un número de teléfono',
          },
        ],
        help: 'El número debe incluir codigo de area sin el 0 y el numero sin el 15'
      },
      input: {
        className: inputPadding,
        type: 'number'
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Nombre del responsable de compras',
        style: {marginTop: '1rem'},
        name: 'nameResponsible',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el nombre del responsable de compras',
          },
        ],
      },
      input: {
        className: inputPadding
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Teléfono del responsable de compras',
        style: {marginTop: '1rem'},
        name: 'responsibleCellPhone',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el teléfono del responsable de compras',
          },
        ],
      },
      input: {
        className: inputPadding
      },
      inputTag: 'Input',
    },
    {
      item: {
        label: 'Email',
        name: 'email',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese un email',
          },
        ],
      },
      input: {
        className: inputPadding
      },
      inputTag: 'Input',
    },
  ];
  return fields;
};

export default NewPharmacyFields;
